import { CancelToken } from 'axios'

import { portalApi } from '@/axios'

import { AuditEvent } from '@/classes/models'

export default class AuditEventService {
    /**
   * Get audit events by meta data / parameters.
   *
   * @param {Context} context
   * @param {TableRequest} parameters
   *
   * @return {Promise}
   */
  static get (context, parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(this.endpoint(context), {
      cancelToken: cancelToken.token,
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    // Map to Event
    request.then(response => {
      response.data = response.data.map(event => new AuditEvent(event))

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  /**
   * Store an event.
   *
   * @param {object} event
   *
   * @return {Promise}
   */
  static post (event) {
    return portalApi.post('/audit-events', event).then(response => {
      return response.data
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context) {
    return `${context.endpoint(['business', 'merchant'])}/audit-events`
  }
}
